import { ApiCall } from './utils'

const bulkLegalize = (params) => ApiCall('post', `/image/bulk/legalize`, params)

export default {
    bulkLegalize
}